import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const ReasonsInput = ({
  splInsOptions = [],
  formData,
  setFormData,
  handlePrescriptionModal,
  errors,
  disabled
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      rsnpres: e.target.value
    }));
  };

  const handleSelect = (value) => {
    setFormData((prev) => ({
      ...prev,
      rsnpres: value
    }));
    setShowOptions(false);
  };

  const displayValue = (() => {
    const matched = splInsOptions.find(
      (opt) => String(opt.value) === String(formData.rsnpres)
    );
    return matched ? matched.key : formData.rsnpres;
  })();

  return (
    <Form.Group className="mb-3 position-relative">
      <div className="d-flex">
        <Form.Control
          disabled={disabled}
          type="text"
          placeholder="Type or select instruction"
          value={displayValue || formData.reason_text}
          onChange={handleChange}
          onFocus={() => setShowOptions(true)}
          onBlur={() => setTimeout(() => setShowOptions(false), 200)}
          isInvalid={!!errors?.rsnpres}
        />
        {Number(localStorage.getItem("roleId")) < 5 && (
          <Button
            variant="outline-secondary"
            id ="btnrsnpres"
            disabled={disabled}
            onClick={handlePrescriptionModal}
            style={{ marginLeft: '8px' }}
          >
            +
          </Button>
        )}
      </div>

      {showOptions && (
        <div
          className="dropdown-menu show w-100 mt-1"
          style={{
            maxHeight: '150px',
            overflowY: 'auto',
            overflowX: 'hidden',
            whiteSpace: 'normal',
            wordBreak: 'break-word'
          }}
        >
          {splInsOptions.length > 0 ? (
            splInsOptions.map((option, index) => (
              <div
                key={index}
                className="dropdown-item"
                style={{ cursor: 'pointer' }}
                onMouseDown={() => handleSelect(option.value)}
              >
                {option.key}
              </div>
            ))
          ) : (
            <div className="dropdown-item text-muted">No suggestions</div>
          )}
        </div>
      )}

      {errors?.rsnpres && (
        <div className="invalid-feedback d-block mt-1">
          {errors.rsnpres}
        </div>
      )}
    </Form.Group>
  );
};

export default ReasonsInput;
